import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { SimNaoPipe } from '../../pipes/sim-nao-pipe';
import { TipoAgendamentoPipe } from '../../pipes/tipo-agendamento-pipe';
import { Procedimento } from '../procedimento';
import { ProcedimentoService } from '../procedimento.service';

@Component({
  selector: 'app-procedimento-list',
  templateUrl: './procedimento-list.component.html',
  styleUrls: ['./procedimento-list.component.css']
})
export class ProcedimentoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'tipoAgendamentoFormatado', 'dilataPupilaFormatado',
    'executaPosDilatacaoFormatado', 'valor', 'disponivelFormatado',
    'details'];

  constructor(private procedimentoService: ProcedimentoService, router: Router,
    dialog: MatDialog, private tipoAgendamentoPipe: TipoAgendamentoPipe,
    private simNaoPipe: SimNaoPipe) {

    super(router, dialog);
  }

  ngOnInit() {
    this.reloadData();

    super.ngOnInit();
  }

  reloadData() {
    this.procedimentoService.listarComProjecao()
      .subscribe(data => {
        // console.log(data)
        this.data = data as Procedimento[];

        this.data = this.configurarformatacoes(this.data);

        this.configurarDataSource();
      }, error => {
        console.log(error);
      });
  }

  configurarformatacoes(data: Procedimento[]) {
    data.forEach(
      (val, index) => {
        data[index].tipoAgendamentoFormatado = this.tipoAgendamentoPipe.transform(data[index].tipoAgendamento)
        data[index].dilataPupilaFormatado = this.simNaoPipe.transform(data[index].dilataPupila)
        data[index].executaPosDilatacaoFormatado = this.simNaoPipe.transform(data[index].executaPosDilatacao)
        data[index].disponivelFormatado = this.simNaoPipe.transform(data[index].disponivel)
        data[index].procedimentoConsultaFormatado = this.simNaoPipe.transform(data[index].procedimentoConsulta)
      });

    return data;
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.procedimentoService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData();
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterProcedimento']);
  }

  details(id: number) {
    this.router.navigate(['manterProcedimento'], {
      state: {
        id: id,
        isUpdate: 'N',
      }
    });
  }

  update(id: number) {
    this.router.navigate(['manterProcedimento'], {
      state: {
        id: id,
        isUpdate: 'S',
      }
    });
  }
}
